import { FormItem } from '@framework/form';
import { yup } from '@framework/validation';
import { Collapse } from 'antd';
import { RichTextAdvancedSchema } from '../../../../../inputs/rich-text-advanced/schema/RichTextAdvancedSchema';
import { StyledDrawerCollapse } from '../../../../../ui/drawer/StyledDrawerCollapse';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { WidgetType } from '../../../Widget';
import { CommonBaseLayoutSchema } from '../../graphics/common/CommonBaseLayoutSchema';
import { CommonButtonConfigComponent } from '../../inputs/common/CommonButtonConfigComponent';
import {
  CommonConfigComponent,
  CommonInputWidgetConfigSchema,
} from '../../inputs/common/CommonInputConfigComponent';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps';
import { ButtonActionSchema } from './actions/ButtonActionSchema';
import { ButtonActionsConfig } from './actions/ButtonActionsConfig';
import { IButtonWidget } from './IButtonWidget';

const { Panel } = Collapse;

export const ButtonWidgetConfigSchema: yup.ObjectSchema<IButtonWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.Button).required(),
    label: RichTextAdvancedSchema.optional().label('Etichetta'),

    // Azioni
    actions: yup.array(ButtonActionSchema).notRequired().label('Azioni'),

    layout: CommonBaseLayoutSchema,
  });

export interface IButtonWidgetConfigComponentProps
  extends IWidgetComponentProps<IButtonWidget> {}

export function ButtonWidgetConfigComponent(
  props: IButtonWidgetConfigComponentProps,
) {
  const options = getWidgetProps(props);
  return (
    <div>
      <StyledDrawerCollapse defaultActiveKey={['general', 'actions']} ghost>
        <Panel header="Impostazioni Generali" key="general">
          {/* Configurazioni comuni */}
          <CommonConfigComponent
            {...props}
            hideConfigPlaceholder={true}
            hideConfigDefaultValue={true}
          />

          <CommonButtonConfigComponent />
        </Panel>
        {/* Panel Azioni⁄ */}
        <Panel header="Azioni del Pulsante" key="actions">
          <FormItem name="actions">
            <ButtonActionsConfig name="actions" />
          </FormItem>
        </Panel>
      </StyledDrawerCollapse>
    </div>
  );
}
